import { useStudioShortcuts } from '@/hooks/use-studio-shortcuts'
import { IDEShellLayout } from './ide-v2/IDEShellLayout'
import { Toaster } from '@/components/toaster'

export function StudioShell() {
  useStudioShortcuts()

  return (
    <>
      <IDEShellLayout>
        {/*
          Sub-project C PR1: rail items 'pages', 'layers', 'components' now
          route to surface wrappers via IDEShellLayout's ActiveSurface switch.
          This fallback shows for the OTHER rail items (preview, events, data,
          code, ds, map, publish, deploy, settings) — wired progressively in
          PR2-4 of Sub-project C.
        */}
        <div className="p-4 text-muted-foreground text-sm">
          Canvas placeholder — surface for this rail item not yet wired.
        </div>
      </IDEShellLayout>
      <Toaster />
    </>
  )
}
